import moment from 'moment';
let searchDate = moment().startOf('year').format('YYYY');
export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), 
	partTypeList: [
            {
                "commCd": "MEA",
                "commCdName": "MEA",
                "commCdType": "PART_G"
            },
            {
                "commCd": "EGA",
                "commCdName": "EGA",
                "commCdType": "PART_G"
            }
        ], 
	mdjTbList: [], 
	dayCols: [], 

	graphBarStackChartInfo: [], 
	graphLineChartInfo: [], 

	isLoading: false 
};

function SEARCH_PARAMS() {
	return {
		partType: 'MEA', 
		searchDate: searchDate 
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
